import classNames from "classnames/bind";
import styles from "./AsidePost.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useNavigate } from "react-router-dom";
import {
  faFacebook,
  faFlickr,
  faInstagram,
  faLinkedin,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import {
  faLeftLong,
  faPencil,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";

import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { fetchPost } from "../../../redux/slice/postSlice";
import { URL } from "../../../routes/url";
import { Button } from "antd";
import { ArrowUpOutlined } from "@ant-design/icons";

const css = classNames.bind(styles);
function AsidePost() {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollY, setScrollY] = useState(false);
  const [searchPost, setSearchPost] = useState("");

  const posts = useAppSelector((state) => state.post.result);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  let query = `current=1&pageSize=6&sort=-createdAt&title=${searchPost}`;
  query += "&populate=categoryId&fields=categoryId._id,categoryId.name";

  const handleFetchPost = () => {
    dispatch(fetchPost({ query }));
  };
  useEffect(() => {
    handleFetchPost();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      // const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      setIsVisible(currentScrollY > 205);

      setScrollY(currentScrollY < documentHeight - 1100);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  function handleClick(event: any, item: any) {
    event.preventDefault(); // Ngăn chuyển hướng đến liên kết mặc định
    const anchor = event.target;
    anchor.removeAttribute("href"); // Loại bỏ thuộc tính href của thẻ a
    navigate(`/post-detail/${item}`);
  }

  const handleSearchPost = () => {
    handleFetchPost();
  };
  return (
    <div
      className={css("aside")}
      style={
        isVisible
          ? {
              position: scrollY ? "fixed" : "relative",
              width: "calc(1200px - (1200px * 0.75))",
              top: scrollY ? -105 : -105,
            }
          : {}
      }>
      <div className={css("info-app")}>
        <p>
          <FontAwesomeIcon icon={faFacebook} size="1x" />
        </p>
        <p>
          <FontAwesomeIcon icon={faLinkedin} size="1x" />
        </p>
        <p>
          <FontAwesomeIcon icon={faYoutube} size="1x" />
        </p>
        <p>
          <FontAwesomeIcon icon={faInstagram} size="1x" />
        </p>
        <p>
          <FontAwesomeIcon icon={faFlickr} size="1x" />
        </p>
      </div>
      <div className={css("search")}>
        <input
          onChange={(e) => setSearchPost(e.target.value)}
          value={searchPost}
          type="text"
          placeholder="Tìm kiếm..."
        />

        <FontAwesomeIcon
          onClick={handleSearchPost}
          className={css("icon-search")}
          icon={faSearch}
          color="#808080"
        />
      </div>
      <div className={css("back-home-sidebar")}>
        <FontAwesomeIcon icon={faLeftLong} size="1x" color="#1677ff" />
        <Link to={URL.CLIENT.HOME}>
          <span>QUAY LẠI TRANG CHỦ</span>
        </Link>
      </div>
      <div className={css("list-title")}>
        <div className={css("title-menu")}>
          <FontAwesomeIcon icon={faPencil} size="1x" color="#1677ff" />{" "}
          <span>Tập bút</span>
        </div>
        <ul>
          {posts &&
            posts.length > 0 &&
            posts.map((item, index) => {
              return (
                <li key={index}>
                  <a href="##" onClick={(e) => handleClick(e, item._id)}>
                    {item.title}
                  </a>
                </li>
              );
            })}
        </ul>
      </div>
      {isVisible && (
        <Button
          className={css("btn-to-top")}
          type="primary"
          style={{ bottom: scrollY ? "19px" : "378px" }}
          onClick={scrollToTop}
          shape="circle"
          icon={<ArrowUpOutlined style={{ fontSize: 25 }} />}></Button>
      )}
    </div>
  );
}

export default AsidePost;
